import type { Component } from "vue"

export type Option<
  TValue extends
    | string
    | number
    | null
    | boolean
    | undefined,
> = {
  value: TValue
  label: string
  icon?: Component
}

export type OptionsMap<
  TValue extends string | number | boolean =
    | string
    | number
    | boolean,
> = Record<string, Option<TValue>>

export type ExtractValue<TMap extends OptionsMap<any>> =
  TMap extends OptionsMap<infer TValue> ? TValue : never

export const buildOptionsFromMap = <
  TValue extends string | number | boolean,
>(
  optionsMap: OptionsMap<TValue>
) => Object.values(optionsMap)
